package com.milta.feature.route.domain.entity

/**
 * A delivery not yet persisted to the backend (DOM-02). Held client-side while the manager is
 * assembling a new route on [com.milta.feature.route.presentation.CreateRouteScreen] — either
 * typed manually or produced by [ImportedDelivery.toDraft] after an Excel import — then sent as
 * the `deliveries` array of `POST /routes` or `POST /routes/{id}/deliveries`.
 */
data class DeliveryDraft(
    val recipientName: String,
    val address: String,
    val phoneNumber: String? = null,
    /** Raw "HH:mm" string, reviewed/corrected client-side (contract révisé DOM-02 — écran C/D du scan OCR). */
    val deadlineTime: String? = null,
    /** Optional, no range validation on the contract beyond >=1 — defaults server-side to 1 (MIL-35). */
    val packageCount: Int? = null,
)
